import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartLineConnectedRegularReportIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.9 22.3q1 .1 1.1 1v3.8q-.1 1-1.1 1.1H18q-1-.1-1.1-1v-3.8q.1-1 1.1-1.1zm4.5-4.6q1 .2 1.1 1.2V27q-.1 1-1.1 1.1h-.8q-1-.1-1.1-1v-8.3q.1-1 1.1-1.1zm4.5 1.6q1 .1 1.1 1v6.8q-.1 1-1.1 1.1H27q-1-.1-1.1-1v-6.8q.1-1 1.1-1.1zM4.4 4.8q1.1 0 1.2 1.2v17.2q.1 1.5 1.6 1.6H15v2.4H7.2a4 4 0 0 1-4-4V6q0-1.1 1.2-1.2M15.2 8q.5 0 .9.4l3.5 3.9L22 10q.8-.8 1.6 0l3.2 3.1q.4.5.4.9v3.3l-1 .1q-.6-.9-1.4-1.3v-1.6l-2-2-2.4 2.3q-.3.4-.8.4t-.9-.4L15.2 11l-4 4.3v4h8.3v1h-1.4q-1.6 0-2.5 1.3H10q-1.1 0-1.2-1.2v-5.5q0-.5.3-.8l5.2-5.7q.4-.4.9-.4" })
});
export default SvgChartLineConnectedRegularReportIcon;
